var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("nav", { staticClass: "top-navigation" }, [
    _c("div", { staticClass: "grid-x" }, [
      _c("div", { staticClass: "large-5 medium-5 small-4 cell" }, [
        _vm.app_env == "local" || _vm.app_env == "development"
          ? _c("span", { staticClass: "development-label" }, [
              _vm._v("\n                Testovací prostředí\n            "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "filters",
            class: { active: _vm.showFilters },
            on: {
              click: function ($event) {
                return _vm.toggleShowFilters()
              },
            },
          },
          [
            _c("img", {
              staticClass: "chevron",
              class: { list: _vm.servicesView == "list" },
              attrs: { src: "/img/chevron-right.svg" },
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "chevron-active",
              class: { list: _vm.servicesView == "list" },
              attrs: { src: "/img/chevron-right-active.svg" },
            }),
            _vm._v(
              " " +
                _vm._s(_vm.$t("filter.showFiltersButton")) +
                "\n            "
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "large-2 medium-2 small-4 cell" }, [
        _c(
          "div",
          {
            staticClass:
              "logo-current-type-block flex-container flex-dir-column align-center-middle",
          },
          [
            _c("router-link", { attrs: { to: { name: "services" } } }, [
              _c("img", {
                staticClass: "logo",
                attrs: {
                  src: "/img/logo-navigation-drivalia.svg",
                  alt: "Drivalia",
                },
              }),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "large-5 medium-5 small-4 cell" }, [
        _c("img", {
          staticClass: "hamburger",
          attrs: { src: "/img/hamburger.svg" },
          on: {
            click: function ($event) {
              return _vm.setShowPopOut()
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "language-switch-container-view" },
          [_c("lang-switcher")],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "logout",
            on: {
              click: function ($event) {
                return _vm.logout()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("auth.logoutButton")))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "license-plate-container-view" }, [
          _c("span", { staticClass: "license-plate-view" }, [
            _vm._v(_vm._s(_vm.licensePlate)),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }